import React, { useEffect, useState, useRef } from 'react';
import { data_user } from '../api/datauser'
import { global } from '../api/global'

function CanalVideos({ artistaid, setvideoid }) {  

    const [videos, setvideos] = useState([])
    const scrollContainerRef = useRef(null)

    useEffect(() => {
        _carregatela()
    }, [])

    async function _carregatela() {
        const videos = await data_user.ListarVideos(artistaid)
        console.log(videos, 'videos')
        setvideos(videos)
    }

    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: -300,
                behavior: 'smooth'
            })
        }
    }

    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: 300,
                behavior: 'smooth'
            })
        }
    }

    return (
        <div className="relative">
            {/* Seta esquerda */}
            <button 
                onClick={scrollLeft}
                className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-2 transition-all duration-200"
                style={{ marginLeft: '8px' }}
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
            </button>

            {/* Container dos vídeos */}
            <div 
                ref={scrollContainerRef}
                className="flex overflow-x-auto scrollbar-hide gap-4 py-4 px-12"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
                {videos.map((video) => (
                    <div 
                        key={video._id} 
                        className="flex-shrink-0 cursor-pointer transition-transform duration-200 hover:scale-105"
                        onClick={() => setvideoid(video._id)}
                    >
                        <div className="w-48 bg-black rounded-lg shadow-md overflow-hidden">
                            <div className="relative">
                                <img 
                                    src={`${global.brl.REACT_APP_FOTO}/${video.foto}.jpg`} 
                                    alt={video.titulo}
                                    className="w-full h-28 object-cover"
                                />
                            
                            </div>
                            <div className="p-2">
                                <h3 className="text-xs font-medium text-white line-clamp-2" title={video.titulo}>
                                    {video.titulo}
                                </h3>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Seta direita */}
            <button 
                onClick={scrollRight}
                className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-2 transition-all duration-200"
                style={{ marginRight: '8px' }}
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </button>

            <style jsx>{`
                .scrollbar-hide::-webkit-scrollbar {
                    display: none;
                }
                .line-clamp-2 {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            `}</style>
        </div>
    )
}

export default CanalVideos